export interface EmbedCodeOptions {
  globalOptions: Record<string, any>;
  optionsPerAsset: Record<string, any>;
}

export default interface EmbedCodeOptionsState {
  globalOptions: Record<string, any>;
  optionsPerAsset: Record<string, any>;
}

export enum GlobalEmbedCodeOptions {
  HIDE_LOGO = 'hideLogo',
  LANGUAGE = 'language',
  HIDE_USER_MENU = 'hideUserMenu',
  HIDE_FOOTER_LINKS = 'hideFooterLinks',
  HIDE_PROTECTED_BY = 'hideProtectedBy',
  BRANDING_ID = 'brandingId',
  SSO_DOMAIN = 'ssoDomain',
  REGISTER_FIRST = 'registerFirst',
  USE_SSO = 'useSSO',
  OAUTH_APP_KEY = 'oauthAppKey',
  ALLOW_REMOVE = 'allowRemove',
  ALLOW_DESTROY = 'allowDestroy',
  FOOTER_LINKS = 'footerLinks',
  USER_MENU_POSITION = 'userMenuPosition',
  DISABLE_REDONATION = 'dontAskForAnotherDonation',
}

export enum PerAssetEmbedCodeOptions {
  NO_PREVIEW = 'noPreview',
  REGISTER_FIRST = 'registerFirst',
  NO_INJECT = 'noInject',
  PRESELECTED_FEE_ID = 'preselectedFeeId',
  SHOW_PREVIEW_PRICES = 'showPreviewPrices',
  DISABLE_VOUCHER = 'disableVoucher',
  BRANDING_ID = 'brandingId',
  ASSET_ID = 'assetId',
  PLAYER_SCRIPTS = 'playerScripts',
  PLAYER_PARAMS = 'playerParams',
  ACCESS_CODE = 'accessCode',
  HIDE_BUY_GIFT_OPTION = 'hideBuyGiftOption',
  HIDE_GIFT_AFTER_PURCHASE = 'hideGiftFlowAfterPurchase',
  RECOMMENDED_PRICE_ID = 'recommendedPriceId',
  RECOMMENDED_PRICE_DESCRIPTION = 'recommendedPriceDescription',
  DISABLE_REDONATION = 'dontAskForAnotherDonation',
}
